export const startMockServiceWorker = async () => {
  const { worker } = await import('@hc-claims/mocks');
  return worker.start();
};
